import { registerDevice } from 'api'
import 'moment/locale/es'
import ons from 'onsenui'
import 'onsenui/css/onsen-css-components.css'
import 'onsenui/css/onsenui.css'
import React from 'react'
import ReactDOM from 'react-dom'

import 'styles/index.css'
import 'typeface-roboto'
import App from './App'
import { unregister } from './registerServiceWorker'

if (ons.platform.isIPhoneX()) {
  document.documentElement.setAttribute('onsflag-iphonex-portrait', '')
}

document.addEventListener(
  'deviceready',
  () => {
    // window.StatusBar.hide()
    window.StatusBar.overlaysWebView(false)

    // One Signal PUSH Notifications
    window.plugins.OneSignal.startInit('d6f8ac2f-4ef2-4800-9ef2-11933470ec18')
      .handleNotificationOpened(jsonData => {
        if (window.onNotification) window.onNotification(jsonData)
        console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData))
      })
      .endInit()

    // Register pushToken
    const pushTokenCallback = pushToken => {
      console.log('Push token', pushToken)
      registerDevice(pushToken)
    }

    window.plugins.OneSignal.addSubscriptionObserver(state => {
      if (state.to.userId) {
        pushTokenCallback(state.to.userId)
      }
    })

    window.plugins.OneSignal.getPermissionSubscriptionState(state => {
      if (state.subscriptionStatus.userId) {
        pushTokenCallback(state.subscriptionStatus.userId)
      }
    })
  },
  false,
)

ReactDOM.render(<App />, document.getElementById('root'))
unregister()



// WEBPACK FOOTER //
// ./src/index.js